"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class BatchFetchEntitiesByExternalIdDoesNotExistError extends client_library_1.ExtendableError {
    constructor() {
        super(`School cannot be found`);
    }
}
exports.default = BatchFetchEntitiesByExternalIdDoesNotExistError;
//# sourceMappingURL=BatchFetchEntitiesByExternalIdDoesNotExistError.js.map